import { Paper, styled } from "@mui/material";

import { useMeasureConfigs } from "hooks/measureConfigHooks";
import { useStudyArea, useStudyAreaResult } from "hooks/studyAreaHooks";

import { CostBenefitsGraphs } from "components/result/CostBenefitsGraphs";
import { Details } from "components/result/Details";
import { LeafletMap } from "components/result/LeafletMap";
import { ThemeGraphs } from "components/result/ThemeGraphs";
import { TotalResult } from "components/result/TotalResult";
import { Print } from "components/utils/Print";

interface Props {
  uuid: string;
}

export function ResultPrintPageLoader(props: Props) {
  const { uuid } = props;
  const { data } = useStudyAreaResult(uuid);
  const { data: studyArea } = useStudyArea(uuid);
  const { data: measureConfigs } = useMeasureConfigs(uuid);

  return (
    <StyledPaper elevation={0}>
      <Print />
      {data && studyArea && (
        <TotalResult
          computationDate={studyArea.computationDate}
          computationVersion={studyArea.computationVersion}
          score={data.score}
          className="total-score-section bottom-margin"
          elevation={0}
        />
      )}

      {data && (
        <ThemeGraphs
          elevation={0}
          className="theme-graph-section bottom-margin"
          themeScores={data.themeScores}
        />
      )}

      {data && (
        <CostBenefitsGraphs
          className="cost-benefit-section top-margin"
          elevation={0}
          costs={data.costs}
          coBenefits={data.coBenefits}
        />
      )}

      {data && studyArea && (
        <Details
          className="details-section top-margin"
          elevation={0}
          studyArea={studyArea}
          adaptationIndicatorValues={data.adaptationIndicatorValues}
        />
      )}
      {studyArea && measureConfigs && (
        <LeafletMap
          elevation={0}
          className="leaflet-map-section"
          studyArea={studyArea}
          measureConfigs={measureConfigs}
        />
      )}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  @media print {
    display: block;
    margin: 1%;
    padding: 8px;
    overflow: unset;

    .leaflet-control {
      display: none;
    }
    .top-margin {
      margin-top: 48px;
    }
  }

  background-color: transparent;
  height: 100%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 2%;
  margin-bottom: 2%;

  [class*="-section"] {
    margin-bottom: 20px;
    background-color: transparent;
  }
  .bottom-margin {
    margin-bottom: 80px;
  }
  .page-break {
    page-break-before: always;
  }

  .total-score-section {
  }

  .theme-graph-section {
    .theme-graphs {
      gap: ${({ theme }) => theme.spacing(10)};
    }
  }

  .cost-benefit-section {
    width: 1000px;
    page-break-before: always;
  }

  .details-section {
    page-break-before: always;
    display: flex;
    flex-direction: column;
  }
  .leaflet-map-section {
    box-shadow: ${({ theme }) => theme.shadows[2]};
    height: 600px;
    width: 1000px;
  }
`;
